import { observer } from "mobx-react-lite";
import { pluralize } from "@/modules/pluralize";
import { MDSSwitchFloaty } from "@/mds/components/buttons/switch-floaty";
import styled from "@emotion/styled";
import { MdsIconKind } from "@/design-system/components/icon";
import { useTabPageStore } from "@/hooks/useTabPageStore";

export const SearchPageFloaty = observer(() => {
  const page = useTabPageStore("searchPage");

  const deepSearchResultsCount = page.deepSearchResults.length;
  const selectedItemsCount = page.listState.selectedItemIds.length;
  const isShowingDeepSearchResults = page.showDeepSearchResults;

  const isVisible = selectedItemsCount === 0 && deepSearchResultsCount > 0;
  const prefix = isShowingDeepSearchResults ? "Showing" : "Show";
  const deepSearchResultsLabel = `${prefix} ${deepSearchResultsCount} deep search ${pluralize(
    deepSearchResultsCount,
    "result",
    "results"
  )}`;

  return (
    <Wrapper isVisible={isVisible}>
      <MDSSwitchFloaty
        label={deepSearchResultsLabel}
        iconKind={MdsIconKind.Radar}
        defaultSelected={page.showDeepSearchResults}
        onChange={(v: boolean) => page.setShowDeepSearchResults(v)}
      />
    </Wrapper>
  );
});

interface WrapperProps {
  isVisible: boolean;
}

const Wrapper = styled.div<WrapperProps>(({ isVisible }) => ({
  opacity: isVisible ? 1 : 0,
  bottom: isVisible ? 10 : -65,
  display: "flex",
  flex: 1,
  justifyContent: "center",
  position: "absolute",
  transition: "all 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)",
  left: 16,
  right: 16,
  maxWidth: "calc(100% - 32px)",
  zIndex: 2,
}));
